import { PropsWithChildren } from 'react';
import { Navigate } from 'react-router-dom';
import type { FeatureFlagName } from '@/components/session/session.store';
import { useSession } from '@/components/session/useSession';
import { PATHS } from '../routes';

type FeatureFlagGuardProps = PropsWithChildren<{
  featureFlag: FeatureFlagName;
  redirectTo?: string;
}>;

/**
 * Guards a route based on a feature flag.
 * If the flag is disabled, redirects to the specified path (or status quo analysis by default).
 */
export function FeatureFlagRoutingGuard({ featureFlag, redirectTo, children }: FeatureFlagGuardProps) {
  const { featureFlags } = useSession();

  if (!featureFlags[featureFlag]) {
    return <Navigate to={redirectTo ?? PATHS.statusQuoAnalysis.buildings()} replace />;
  }

  return <>{children}</>;
}
